export enum ActivityRepetition {
    NONE = 'NONE',
    DAY = 'DAY',
    WEEK = 'WEEK'
}
